import { XCircle } from "react-feather";
import { Row, Table } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { CartType } from "../../../../Types/EcommerceType";
import { removeCartData } from "../../../../ReduxToolkit/Reducers/ECommerce/CartSlice";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";
import { Href } from "../../../../Constants/Constants";
import EmptyCart from "./EmptyCart";
import { Link } from "react-router-dom";
import { CartTableHeader } from "../../../../Data/Applications/ECommerce/ECommerce";
import { CartQuantityButton } from "./CartQuantityButton";
import CartAction from "./CartAction";
import { Fragment } from "react/jsx-runtime";

export const CartData = () => {
  const dispatch = useAppDispatch();
  const { symbol } = useAppSelector((state) => state.product);
  const { cart } = useAppSelector((state) => state.cartData);
  const removeFromCart = (item: CartType) => dispatch(removeCartData(item.id));

  return (
    <Fragment>
      {cart && cart.length > 0 ? (
        <Row>
          <div className="order-history custom-scrollbar table-responsive wishlist">
            <Table className="table-bordered">
              <thead>
                <tr>
                  {CartTableHeader.map((items, i) => (<th key={i}>{items}</th>))}
                </tr>
              </thead>
              <tbody>
                {cart.map((item, index) => (
                  <tr key={index}>
                    <td><Image className="img-fluid img-40" src={dynamicImage(`${item.image}`)} alt={Href} /></td>
                    <td><div className="product-name"><a href={Href}>{item.name}</a></div></td>
                    <td>{symbol}{item.price}</td>
                    <CartQuantityButton item={item} />
                    <td><Link to={Href} onClick={() => removeFromCart(item)}><XCircle /></Link></td>
                    <td>{symbol}{item.price * item.total}</td>
                  </tr>
                ))}
                <CartAction/>
              </tbody>
            </Table>
          </div>
        </Row>
      ) : (
        <EmptyCart />
      )}
    </Fragment>
  );
};
